module.exports = "<div id=\"container\">\n    <div id=\"text\"></div>\n  </div>"